const baseSections = Object.freeze([
    {
        info: {
            title: 'Catalog',
            text: 'Add metafields to item types that are related to your product catalog.',
            url: '#'
        },
        categories: [
            {
                name: 'Products',
                to: { name: 'products.manage' },
                icon: 'products',
                editUrl: { name: 'products.edit' },
                editUrlPlacement: 'inner'
            },
            {
                name: 'Variants',
                to: { name: 'variants.manage' },
                icon: 'mobile-vertical-dots',
                editUrl: { name: 'variants.edit' },
                editUrlPlacement: 'inner'
            },
            {
                name: 'Collections',
                to: { name: 'collections.manage' },
                icon: 'images',
                editUrl: { name: 'collections.edit' },
                editUrlPlacement: 'inner'
            }
        ]
    },
    {
        info: {
            title: 'E-commerce',
            text: 'Add metafields to element types that are related to e-commerce.',
            url: '#'
        },
        categories: [
            {
                name: 'Customers',
                to: { name: 'customers.manage' },
                icon: 'customers'
            },
            {
                name: 'Orders',
                to: { name: 'orders.manage' },
                icon: 'orders'
            }
        ]
    },
    {
        info: {
            title: 'CMS',
            text: 'Add metafields to item types that are related to Pages, Blog posts or Blogs.',
            url: '#'
        },
        categories: [
            {
                name: 'Pages',
                to: { name: 'pages.manage' },
                icon: 'note',
                editUrl: { name: 'pages.edit' },
                editUrlPlacement: 'inner'
            },
            {
                name: 'Blogs',
                to: { name: 'blogs.manage' },
                icon: 'text-block-2',
                editUrl: { name: 'blogs.edit' },
                editUrlPlacement: 'inner'
            },
            {
                name: 'Blog posts',
                to: { name: 'articles.manage' },
                icon: 'text-block',
                editUrl: { name: 'articles.edit' },
                editUrlPlacement: 'inner'
            }
        ]
    },
    {
        info: {
            title: 'Globals',
            text: 'You can add metafields that are global and accessible across the entire Store.',
            url: '#'
        },
        listLayout: true,
        categories: [
            {
                name: 'Globals',
                to: { name: 'globals.manage' },
                icon: 'tools',
                editUrl: { name: 'globals.edit' },
                editUrlPlacement: 'outer'
            }
        ]
    }
])

const customObjSection = Object.freeze({
    info: {
        title: 'Custom objects',
        text:
            'Custom objects are reusable blocks of configurable data that you can fill once, and then include in any Airfields schema.',
        url: '#'
    },
    listLayout: true
})

const settingsSection = Object.freeze({
    info: {
        title: 'Settings',
        text: 'Manage your Airfields settings.',
        url: '#'
    },
    categories: [
        {
            name: 'Integrations',
            to: { name: 'integrations.manage' },
            icon: 'tools'
        }
    ]
})

export { baseSections, customObjSection, settingsSection }



// WEBPACK FOOTER //
// ./src/data/homepage.js